import { Fragment } from "react";
import { Grid } from "@mui/material";

import FormOne from "./forms/CreateCampaignFirstForm";
import FormTwo from "./forms/CreateCampaignSecondForm";
import FormThird from "./forms/CreateCampaignThirdForm";
import CampaignLiveUser from "../CampaignLiveUser";
import FormSeventh from "./forms/PreferredCampaignChannel";
import { Paper } from "../../../../components";
import FormQueryType from "./forms/QueryType";

export default function AllForms({
  audiences,
  editState,
  liveUsers,
  categories,
  formikProps,
  takeUpOffer,
  audienceData,
  component = "",
  brandDetails,
  setBrandDetails,
  setAudienceData,
  setAudienceCreated,
  preferredChannels,
  brandIdentity,
  forceClick,
  isSubmitted,
  audienceSize,
  channelSectionRef,
}) {
  return (
    <Paper>
      <FormOne
        categories={categories}
        brandDetails={brandDetails}
        setBrandDetails={setBrandDetails}
        formikProps={formikProps}
        editState={editState}
        component={component}
        brandIdentity={brandIdentity}
      />

      <Grid size={12} />

      <FormThird
        brandIdentity={brandIdentity}
        formikProps={formikProps}
        editState={editState}
        component={component}
      />

      <Grid size={12} />

      <FormTwo
        audienceSize={audienceSize}
        setAudienceData={setAudienceData}
        formikProps={formikProps}
        audiences={audiences}
        editState={editState}
        component={component}
        brandIdentity={brandIdentity}
        audienceData={audienceData}
        setAudienceCreated={setAudienceCreated}
      />

      <Grid size={12} />

      <FormQueryType formikProps={formikProps} editState={editState} />

      <Grid size={12} />

      {component !== "request" && (
        <Fragment>
          <Grid size={12} />

          <Grid size={12}>
            <FormSeventh
              channelSectionRef={channelSectionRef}
              forceClick={forceClick}
              isDisabled={isSubmitted}
              editState={editState}
              formikProps={formikProps}
              preferredChannels={preferredChannels}
            />
          </Grid>
        </Fragment>
      )}

      {brandIdentity && (
        <CampaignLiveUser
          takeUpOffer={takeUpOffer}
          liveUsers={liveUsers}
          component={component}
        />
      )}
    </Paper>
  );
}
